<template lang="pug">
  .recent-invoices
    SectionTitle(:text="orderTitle").text-center
    RecentInvoice(v-for="invoice in recentInvoices" :invoice="invoice" :key="invoice.id")

</template>

<script>
  import { mapState } from "vuex";
  import SectionTitle from "../../../SectionTitle";

  export default {
    name: "WelcomeRecentInvoices",
    components: {
      'RecentInvoice': () => import('./RecentInvoice'),
      SectionTitle
    },

    computed: {
      ...mapState('customer', [
        'recentInvoices'
      ]),

      orderTitle() {
        return `Your order${this.recentInvoices.length > 1 ? 's' : ''}`;
      }
    }
  }
</script>

<style scoped lang="stylus">
  .section-title
    padding 1em

  .recent-invoices
    padding-bottom 2em

  .recent-invoice
    &:not(:last-child)
      padding-bottom 1em
      margin-bottom 1.5em
      border-bottom 1px solid color-fog-light

</style>
